import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Node } from '@models/node/Node';
import { Response } from '@models/response-api/ResponseApi';
import { map } from 'rxjs';
import { toItems } from '@mappers/catalog/catalog';
import { Catalog } from '@models/catalog/Catalog';
import { NodeParams } from '@base/NodeParams';

@Injectable({
  providedIn: 'root'
})
export class NodeService extends NodeParams {
  private url = `${environment.hostAPI}`;

  constructor(private http: HttpClient) {
    super()
   }

  getAllContents(node: Node) {
    const url = `${this.url}/nodes/${node.subsystemId}/all-contents`;
    const params = this.getParams(node);
    return this.http.get<Response>(url, {params});
  }

  getAllContentsV2(node: Node) {
    const url = `${this.url}/nodes/${node.subsystemId}/all-contents-v2`;
    const params = this.getParams(node);
    return this.http.get<Response>(url, {params});
  }

  getAcademicManager(node: Node) {
    const url = `${this.url}/nodes/${node.subsystemId}/academic-manager`;
    const params = this.getParams(node);
    return this.http.get<Response>(url, {params});
  }

  getNodeNested(parentId: number) {
    const url = `${this.url}/nodes/getNextLevel?parentId=${parentId}`;
    return this.http.get<Response>(url)
    .pipe(map(x => ({
      ...x,
      data: toItems(x.data as Catalog[])
    })));
  }

  getNodeNestedV2(parentId: number) {
    const url = `${this.url}/nodes/getNextLevelV2?parentId=${parentId}`;
    return this.http.get<Response>(url)
    .pipe(map(x => ({
      ...x,
      data: toItems(x.data as Catalog[])
    })));
  }
}


